import { render, staticRenderFns } from "./SchedulingObject.vue?vue&type=template&id=31a580c0&"
import script from "./SchedulingObject.vue?vue&type=script&lang=ts&"
export * from "./SchedulingObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports